import { Mosaic } from "react-loading-indicators";

const Loader = () => {
    return (
        <Mosaic color={["#34C759", "#29abe2"]} size="small" text="loading" textColor="#29abe2" />
    );
}

export default Loader;